import { render } from "./MeetingRequestsAdmin.vue?vue&type=template&id=5d7a8186"
import script from "./MeetingRequestsAdmin.vue?vue&type=script&lang=js"
export * from "./MeetingRequestsAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__